export default () => {
  return [
    {
      'id': 1,
      'title': 'Personligt projekt'
    },
    {
      'id': 2,
      'title': 'Stadium Promotion'
    },
    {
      'id': 3,
      'title': 'Hat On Lady'
    },
    {
      'id': 4,
      'title': 'Wackes'
    },
    {
      'id': 5,
      'title': 'Ecoscoter'
    },
    {
      'id': 6,
      'title': 'Metallica'
    },
    {
      'id': 7,
      'title': 'Engström med flera'
    },
    {
      'id': 8,
      'title': 'Flera uppdragsgivare'
    },
    {
      'id': 9,
      'title': 'Pontus Olgrim'
    },
    {
      'id': 10,
      'title': 'Stockholmsmässan'
    },
    {
      'id': 11,
      'title': 'Challengize'
    },
    {
      'id': 12,
      'title': 'Levels'
    },
    {
      'id': 13,
      'title': 'Grepp Kommunikation'
    }
  ];
};
